// Simple toast implementation (simplified version of shadcn/ui's toast)
export const toast = ({ title, description, variant = "default" }) => {
  // Create toast container if it doesn't exist
  let toastContainer = document.getElementById('toast-container');

  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    toastContainer.style.position = 'fixed';
    toastContainer.style.top = '1rem';
    toastContainer.style.right = '1rem';
    toastContainer.style.display = 'flex';
    toastContainer.style.flexDirection = 'column';
    toastContainer.style.gap = '0.5rem';
    toastContainer.style.zIndex = '9999';
    document.body.appendChild(toastContainer);
  }

  // Create toast element
  const toastEl = document.createElement('div');
  toastEl.style.padding = '1rem';
  toastEl.style.borderRadius = '0.375rem';
  toastEl.style.backgroundColor = variant === 'destructive' ? '#f87171' : '#ffffff';
  toastEl.style.color = variant === 'destructive' ? '#ffffff' : '#232946';
  toastEl.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
  toastEl.style.minWidth = '200px';
  toastEl.style.animation = 'slide-in 0.2s ease-out';
  toastEl.style.direction = 'rtl';

  // Add title if present
  if (title) {
    const titleEl = document.createElement('div');
    titleEl.style.fontWeight = 'bold';
    titleEl.innerText = title;
    toastEl.appendChild(titleEl);
  }

  // Add description if present
  if (description) {
    const descEl = document.createElement('div');
    descEl.innerText = description;
    descEl.style.fontSize = '0.875rem';
    toastEl.appendChild(descEl);
  }

  // Add to container
  toastContainer.appendChild(toastEl);

  // Add CSS animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slide-in {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slide-out {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
  `;
  document.head.appendChild(style);

  // Auto remove after 5 seconds
  setTimeout(() => {
    toastEl.style.animation = 'slide-out 0.2s ease-out forwards';
    setTimeout(() => {
      if (toastContainer.contains(toastEl)) {
        toastContainer.removeChild(toastEl);
      }
    }, 200);
  }, 5000);
};